import { Box } from '@mui/material';
import { BodyPix } from '@tensorflow-models/body-pix';
import { useEffect } from 'react';
import { BackgroundConfig } from '../helpers/backgroundHelper';
import { PostProcessingConfig } from '../helpers/postProcessingHelper';
import { SegmentationConfig } from '../helpers/segmentationHelper';
import { SourcePlayback } from '../helpers/sourceHelper';
import useRenderingPipeline from '../hooks/useRenderingPipeline';
import { TFLite } from '../hooks/useTFLite';
import RenderMeetingViewTemplate from './meetingViewTemplates/renderMeetingViewTemplate';

type OutputViewerProps = {
  sourcePlayback: SourcePlayback;
  backgroundConfig: BackgroundConfig;
  segmentationConfig: SegmentationConfig;
  postProcessingConfig: PostProcessingConfig;
  bodyPix: BodyPix;
  tflite: TFLite;
};

function OutputViewer(props: OutputViewerProps) {
  const {
    pipeline,
    backgroundImageRef,
    canvasRef,
    // fps,
    // durations: [resizingDuration, inferenceDuration, postProcessingDuration],
  } = useRenderingPipeline(
    props.sourcePlayback,
    props.backgroundConfig,
    props.segmentationConfig,
    props.bodyPix,
    props.tflite,
  );

  useEffect(() => {
    if (pipeline) {
      pipeline.updatePostProcessingConfig(props.postProcessingConfig);
    }
  }, [pipeline, props.postProcessingConfig]);

  // const statDetails = [
  //   `resizing ${resizingDuration}ms`,
  //   `inference ${inferenceDuration}ms`,
  //   `post-processing ${postProcessingDuration}ms`,
  // ];
  // const stats = `${Math.round(fps)} fps (${statDetails.join(', ')})`;

  return (
    <Box sx={{ flex: 1, position: 'relative' }}>
      {props.backgroundConfig.type === 'image' && (
        <Box
          component={'img'}
          ref={backgroundImageRef}
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          src={
            props.backgroundConfig.url instanceof Blob
              ? URL.createObjectURL(props.backgroundConfig.url)
              : props.backgroundConfig.url
          }
          alt=""
          hidden={props.segmentationConfig.pipeline === 'webgl2'}
        />
      )}
      <RenderMeetingViewTemplate />
      {/* <MeetingTemplateOne /> */}
      <canvas
        // The key attribute is required to create a new canvas when switching
        // context mode
        key={props.segmentationConfig.pipeline}
        ref={canvasRef}
        width={props.sourcePlayback.width}
        height={props.sourcePlayback.height}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      {/* <Typography
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          textAlign: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.48)',
          color: (theme) => theme.palette.common.white,
        }}
        variant="caption"
      >
        {stats}
      </Typography> */}
    </Box>
  );
}

export default OutputViewer;
